<template>
  <div class="card-border h-100">
    <div class="top-section row m-3">
      <div class="col-7 pt-2">
        <p class="card-title">{{ smallTitle }}</p>
        <h3>{{ mainTitle }}</h3>
        <p class="pt-2">
          {{ description }}
        </p>
      </div>
      <div class="col-5 text-center align-self-center">
        <img :src="img" class="img-fluid" />
      </div>
    </div>
    <div class="row card-button px-3 py-1 mb-0">
      <div class="col-sm-1 align-self-center">
        <p class="button-plus mb-0"><i :class="buttonIcon"></i></p>
      </div>
      <div class="col-sm-10 align-self-center">
        <p class="mb-0">{{ buttonText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'SettingsCard',
  props: {
    smallTitle: {
      type: String,
      default: '',
    },
    mainTitle: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonIcon: {
      type: String,
      default: 'fal fa-plus',
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.card-border {
  border: solid 1px $medium-gray;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &:hover {
    border-color: $coral;
    .card-button {
      color: $white;
      background-color: $coral;
      border-top-color: $coral;
    }
    .button-plus {
      color: $white;
    }
  }
}
.card-title {
  color: $coral;
}
.card-button {
  border-top: solid 1px $medium-gray;
}
.button-plus {
  color: $coral;
  font-size: 22px;
}
</style>
